import {Component, EventEmitter, Inject, Input, OnInit, Output} from "@angular/core";
import {WorkflowhttpService} from "@app/workflow-common/services/workflowhttp.service";

@Component({
    selector: 'app-conditional-delay-block',
    templateUrl: './conditional-delay-block-component.html',
})
export class ConditionalDelayBlockComponent implements OnInit {

    name:string = 'conditionalDelayBlock';
    @Input() inputModel:any;
    @Input() activeField:any = {};
    @Input() isConditional:boolean = true;
    @Input() isEdit:boolean = false;
    @Input() operators:any;
    @Input() isMarketPlaceView:boolean = false;
    @Input() deleteMessage:string;
    @Input() warningMessage:string;
    @Input() workflowType: string = 'Custom';
    @Input() diagramOptions: any = {};
    @Input() status: any;

    @Output() outputModel:EventEmitter<any> = new EventEmitter<any>();
    @Output() close:EventEmitter<any> = new EventEmitter<any>();
    @Input() isReadOnlyMode:boolean = false;

    conditionalFields:any = [];
    units:any = [];
    minutesInterval: any[] = Array.from(Array(60).keys());
    hoursInterval: any[] = Array.from(Array(24).keys());
    daysInterval: any[] = Array.from(Array(31).keys());
    monthsInterval: any[] = Array.from(Array(13).keys());
    saving: boolean = false;
    showDeleteBtn:boolean;
    oldModel: any;
    newModel: any

    constructor(
        @Inject('confirmationBoxHelper') private confirmationBoxHelper,
        @Inject('$scope') private ajsScope,
        public workflowService: WorkflowhttpService,
    ) { }

    ngOnInit(): void {
        this.oldModel = JSON.stringify(Object.assign({}, this.inputModel));
        this.showDeleteBtn = this.isMarketPlaceView ? false : this.isEdit;
        this.units = this.inputModel.config.units.filter( unit => unit == 'days' || unit == 'months');
        this.conditionalFields = this.inputModel.config.fields.filter( item => item.type === 'date');
    }

    onChangeUnit(event:any) {
        if((this.inputModel.model.unit == 'months' && this.inputModel.model.interval > 12) || (this.inputModel.model.unit == 'days' && this.inputModel.model.interval > 30) || (this.inputModel.model.unit == 'hours' && this.inputModel.model.interval > 23)){
            this.inputModel.model.interval = 0;
        }
    }

    validateItems() {
        if(this.workflowType == 'Sequence' && this.diagramOptions['mode'] == 'sequence_config') {
            return false;
        }
        if(this.isConditional) {
            let condValue;
            if(typeof this.inputModel.condition['value'] == "number") {
                condValue = false;
            }
            else {
                condValue = this.inputModel.condition.value==''
            }
            return this.inputModel.condition.operator ==='' || condValue || this.inputModel.model.interval == 0;
        }
        else
            return this.inputModel.model.col_name === '' || this.inputModel.model.interval==0;
    }

    addValue() {
        this.saving=true;
        this.newModel = JSON.stringify(Object.assign({}, this.inputModel));
        if( this.oldModel === this.newModel ){
            this.workflowService.triggerEvent({'isUpdated' : false ,'isEdit' : this.isEdit,'action' : 'valueChanged'});
        }else{
            this.workflowService.triggerEvent({'isUpdated' : true ,'isEdit' : this.isEdit,'action' : 'valueChanged'});
        }
        setTimeout(() =>{
            this.outputModel.emit(this.inputModel);
        },0)
    }

    closeModal() {
        this.close.emit(this.isEdit);
    }

    removeCell() {
        this.confirmationBoxHelper
            .getConfirmation(this.deleteMessage, this.ajsScope)
            .then(() => {
                this.close.emit('remove');
            });
    }

}
